<template>
  <inspector-frame v-if="!!key" @close="close" :x="-210" :y="-160">
    <div class="ItemDetail" :style="{
      backgroundImage: url
    }">
      <div class="body">
        <form class="edit">
          <input type="hidden" v-model="formData.imageKey">
          <div class="item">
            <div class="input">
              <textarea v-model="text" @mousedown.stop></textarea>
            </div>
          </div>
          <div class="controls">
            <a class="btn" @click.prevent="selectImage">画像設定</a>
            <a class="btn" @click.prevent="addTo(key)">盤面に追加</a>
            <a class="btn" @click.prevent="save">保存</a>
            <a class="btn" @click.prevent="remove(key)">削除</a>
          </div>
        </form>
      </div>
    </div>
  </inspector-frame>
</template>
<script>
import inspectorFrame from '../frames/inspector'
export default {
  components: { 'inspector-frame': inspectorFrame },
  computed: {
    key() {
      return this.$store.getters['items/$currentKey']
    },
    len() {
      return this.$store.getters['itemList/$items'].length
    },
    emptyIndex() {
      const sortedItem = this.$store.getters['itemList/$sorted']
      let index = 0
      for (; index < sortedItem.length; ++index) {
        if (index !== sortedItem[index].placeIndex) {
          break
        }
      }
      return index
    },
    nextIndex() {
      const sortedItem = this.$store.getters['itemList/$sorted']
      const lastIndex = sortedItem.length - 1
      if (lastIndex >= 0) {
        return sortedItem[lastIndex].placeIndex + 1
      } else {
        return 0
      }
    },
    formData() {
      return this.$store.getters['items/$currentData']
    },
    origin() {
      return this.$store.getters['items/$get'](this.key)
    },
    url() {
      return this.$store.getters['images/getBackgroundUrl'](this.$store.getters['items/$get'](this.key).imageKey)
    },
    text: {
      get() {
        return this.formData.text
      },
      set(value) {
        this.$store.commit('items/$change', { key: 'text', value })
      }
    }
  },
  methods: {
    save(e) {
      this.$store.dispatch('items/$save')
    },
    remove(key) {
      this.$store.dispatch('items/$remove', key)
    },
    close() {
      this.$store.commit('items/$checkout', null)
    },
    selectImage() {
      this.$store.commit('selectors/open', {
        tags: ['items'],
        action: 'items/saveImage',
        context: { key: this.key }
      })
    },
    addTo(key) {
      if (!this.$store.getters['itemList/$get'](key)) {
        const size = 70
        const column = 10
        const placeIndex = this.nextIndex
        this.$store.dispatch('itemList/$insert', {
          key: this.key,
          data: {
            itemKey: this.key,
            x: -(size * column * 0.5) + (placeIndex * size) % (size * column),
            y: ~~(placeIndex / column) * size,
            placeIndex: placeIndex
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.ItemDetail {
  width: 420px;
  height: 320px;
  display: flex;
  background-size: cover;
  background-position: 50% 50%;
  /*flex-flow: column;*/
}
.body {
  padding: 10px;
  flex: 1;
  background: rgba(255, 255, 255, 0.75);
}
textarea {
  border: none;
  display: block;
  height: 278px;
  background: none;
  color: #000;
}
.controls {
  margin-top: 4px;
  display: flex;
}
.btn {
  margin-right: 4px;
  border-radius: 2px;
  padding: 4px 7px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  text-align: center;
  font-size: 10px;
  /* color: #222; */
}
</style>
